module.exports = __webpack_public_path__ + "static/img/ic_no_cert.5f0ef200.png";